import { render, staticRenderFns } from "./HotspotOrder.vue?vue&type=template&id=3dd373d0"
import script from "./HotspotOrder.vue?vue&type=script&lang=js"
export * from "./HotspotOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports